// src/pages/NotFound.tsx
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Helmet>
        <title>404 - Page Not Found | Priya Pareek</title>
        <meta name="description" content="The page you are looking for does not exist. Return to Priya Pareek's portfolio homepage." />
      </Helmet>
      <Navbar />
      <main className="flex-grow flex items-center justify-center px-4 py-24">
        <div className="glass-card max-w-md w-full text-center p-8">
          <h1 className="text-5xl font-display font-bold text-primary mb-4">404</h1>
          <h2 className="text-2xl font-display font-medium text-foreground mb-4">Page Not Found</h2>
          <p className="text-muted-foreground mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Button asChild size="lg" className="inline-flex items-center gap-2">
            <Link to="/">
              <ArrowLeft className="h-4 w-4" />
              Back to Home
            </Link>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;